import { Cookies } from "@stripe-internal/stripe-cookies";
import createCookieEventListener from "./createCookieEventListener";
const emptyConfig = {};
const configMap = new WeakMap();
export default function initCookie(config, reports) {
    const potentialCookieObj = configMap.get(config !== null && config !== void 0 ? config : emptyConfig);
    if (potentialCookieObj) {
        return potentialCookieObj;
    }
    const stripeCookie = new Cookies({
        domainOverrides: config === null || config === void 0 ? void 0 : config.cookieDomainOverrides,
        enforcementMode: config === null || config === void 0 ? void 0 : config.enforcementMode
    });
    const eventListener = createCookieEventListener(stripeCookie, reports);
    const cookieObj = {
        stripeCookie,
        eventListener
    };
    configMap.set(config !== null && config !== void 0 ? config : emptyConfig, cookieObj);
    return cookieObj;
}

//# sourceMappingURL=initCookie.js.map